module.exports = "images/wall-switch-3-b51cadd7f1150e3aee6d24ba6c6ae465.png";